export function isUsingNewLayout(locale) {
  const supportedLocales = ['en', 'en_us', 'tr_tr']
  return supportedLocales.includes(locale)
}
